export default {
    title: 'Zwierzęta',
    subtitle: '{n} zwierzę | {n} zwierzęta | {n} zwierząt',
    newPet: 'Nowe zwierzę',
    search: 'Szukaj zwierzęcia',
    add: {
        placeholder: 'Dodaj zwierzę…',
        save: 'Dodaj',
    },
    species: {
        dog: 'Pies',
        cat: 'Kot',
        rabbit: 'Królik',
        bird: 'Ptak',
        fish: 'Ryba',
        other: 'Inne',
    },
    age: {
        years: '{n} rok | {n} lata | {n} lat',
        months: '{n} mies.',
        weeks: '{n} tyg.',
    },
    fields: {
        name: 'Imię',
        namePlaceholder: 'Imię',
        species: 'Gatunek',
        breed: 'Rasa',
        breedPlaceholder: 'np. jamnik, dachowiec',
        birthDate: 'Data urodzenia',
    },
    weight: {
        title: 'Waga',
        add: 'Dodaj pomiar',
        kg: 'Waga w kilogramach',
        kgPlaceholder: 'np. 12,4',
        date: 'Dzień pomiaru',
        save: 'Zapisz',
        cancel: 'Anuluj',
        remove: 'Usuń pomiar',
        empty: 'Jeszcze bez pomiarów. Jeden na dzień — kolejny tego samego dnia zastąpi poprzedni.',
        chartAria: 'Wykres wagi: {n} pomiarów',
        all: 'Wszystkie ({n})',
        less: 'Mniej',
    },
    notes: {
        title: 'Notatka',
        placeholder: 'Karma, weterynarz z telefonem, alergie, numer chipa…',
    },
    empty: {
        title: 'Nie ma tu jeszcze zwierząt',
        text: 'Dodaj swojego zwierzaka — szczepienia, odrobaczanie i wizyty u weterynarza przypomną się same.',
        noMatchTitle: 'Nic nie pasuje',
        noMatchText: 'Zmień frazę albo wyczyść pole szukania.',
    },
    pick: {
        title: 'Wybierz zwierzę',
        text: 'Albo dodaj nowe w polu nad listą.',
    },
    toolbar: {
        back: 'Wróć do listy',
        remove: 'Usuń zwierzę',
        saving: 'Zapisywanie…',
        saveError: 'Nie udało się zapisać — spróbujemy przy następnej zmianie',
    },
    toast: {
        removed: 'Usunięto: {name}',
    },
    help: {
        add: {
            title: 'Dodaj zwierzę',
            text: 'Wpisz imię, wybierz gatunek i naciśnij Enter. Resztę uzupełnisz po prawej.',
            more: 'Asystent też doda zwierzę, gdy powiesz np. „Burek waży 12 kg" albo „zaszczepiłem psa Burka".',
        },
        list: {
            title: 'Twoje zwierzęta',
            text: 'Na górze te, którym najbliżej do obsługi. Plakietka mówi, co i kiedy — „za 5 dni · odrobaczanie".',
            more: 'Pomarańczowa plakietka znaczy, że termin już minął.',
        },
        cares: {
            title: 'Obsługi',
            text: 'Szczepienie, odrobaczanie, kleszcze… Ustaw, co ile miesięcy, a „Zrobione" zapisze dzień i przesunie następny termin.',
            more: 'Termin możesz też wpisać ręcznie (np. gdy weterynarz każe przyjść za dwa tygodnie) — obowiązuje do następnego „Zrobione". Tydzień wcześniej obsługa pojawi się w „Teraz" i w Planerze.',
        },
        weight: {
            title: 'Waga',
            text: 'Dodawaj pomiary, a wykres pokaże, jak zmienia się waga.',
            more: 'Jeden pomiar na dzień — drugi tego samego dnia zastępuje pierwszy.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Zwierzętach',
            description: 'Miejsce na Twoje zwierzaki: szczepienia, odrobaczanie, wizyty u weterynarza i waga. Terminy przypomną się same.',
        },
        pet: {
            title: 'Zwierzę',
            description: 'Po prawej: imię, gatunek, rasa i data urodzenia, obsługi z przyciskiem „Zrobione", waga z wykresem i notatka. Wszystko zapisuje się samo.',
        },
        end: {
            title: 'To wszystko',
            description: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy sekcji wyjaśnia ją bez przewodnika.',
        },
    },
    firstSteps: {
        pet: {
            title: 'Pierwsze zwierzę',
            action: 'Dodaj zwierzę',
            what: 'Wpisz imię w pole „Dodaj zwierzę…", wybierz gatunek i naciśnij Enter.',
            why: 'Obsługi i waga są przy zwierzęciu.',
        },
        care: {
            title: 'Obsługa',
            action: 'Dodaj obsługę',
            what: 'Otwórz zwierzę i dodaj np. szczepienie albo odrobaczanie — z podpowiedzi albo pod własną nazwą.',
            why: 'Termin przypomni się w „Teraz" i w Planerze.',
        },
        done: {
            title: 'Zrobione',
            action: 'Zapisz wykonanie',
            what: 'Kliknij „Zrobione" przy obsłudze — z dniem, kosztem i notatką.',
            why: 'Następny termin policzy się od tego dnia.',
        },
        weight: {
            title: 'Waga',
            action: 'Dodaj pomiar',
            what: 'Dodaj pierwszy pomiar wagi.',
            why: 'Z kolejnymi pomiarami zobaczysz na wykresie, jak się zmienia.',
        },
    },
};
